export const POST_DEALER_CACHE_SYNC_API_REQUEST = "POST_DEALER_CACHE_SYNC_API_REQUEST";
export const POST_DEALER_CACHE_SYNC_API_SUCCESS = "POST_DEALER_CACHE_SYNC_API_SUCCESS";
export const POST_DEALER_CACHE_SYNC_API_ERROR = "POST_DEALER_CACHE_SYNC_API_ERROR";

export const POST_LISTING_DEPARTMENT_CACHE_API_REQUEST = "POST_LISTING_DEPARTMENT_CACHE_API_REQUEST";
export const POST_LISTING_DEPARTMENT_CACHE_API_SUCCESS = "POST_LISTING_DEPARTMENT_CACHE_API_SUCCESS";
export const POST_LISTING_DEPARTMENT_CACHE_API_ERROR = "POST_LISTING_DEPARTMENT_CACHE_API_ERROR";
